import { IeLynxObject } from "../../common/models/eLynxObject";
import { AlarmNotificationEndingReasonEnum } from "../../common/enums/AlarmNotificationEndingReasonEnum";
import { ControlActionEnum } from "../../common/enums/ControlActionEnum";
import { IMemoModel } from "../../common/models/IMemoModel";
import { FormFeatureEnum } from "../../views/object-form-view/Models";
import { WaterLossCauseEnum } from "../../common/enums/WaterLossCauseEnum";
import { ApplicationMimeTypesEnum } from "../../common/enums/ApplicationMimeTypesEnum";
import { ISortParameters } from "../../common/models/ISortParameters";

export interface IAlarmHistoryEventModel {
    timestamp: string;
    tagID: number;
    tagName: string;
    discrete: boolean;
    value: number;
    listText?: string;
    uom: string;
    setPointName: string;
    inAlarm: boolean;
    alarmColor: string;

    acknowledged: boolean;
    acknowledgedBy: string;
    alarmEndingReason?: AlarmNotificationEndingReasonEnum;
    ackColor: string;
    acknowledgedTimestamp?: string;

    acknowledgedText?: string;

    alarmDuration: number;
    returnToNormal: string;

    object: IeLynxObject;
}

export interface IControlHistoryModel {
    timestamp: string;
    newValue: string;
    newValueNumber: number;
    oldValue: string;
    oldValueNumber: number;
    userLogin: string;
    additionalInformation: string;

    action?: ControlActionEnum;
    objectID?: number;
    objectName?: string;
    userName?: string;
    uom?: string;

    object?: IeLynxObject;
}

export interface IDiagnosticEventModel {
    id: string;
    ruleName: string;
    ruleID?: number;
    note: string;
    createdTime: Date | string;
    createdBy: string;
    object: IeLynxObject;
    startTime: Date | string;
    endTime: Date | string;
    manual: boolean;
}

export interface IDataQualityEventModel extends IDiagnosticEventModel {
    tagName: string;
}

export interface IFormEventModel {
    id: string;
    formInstanceID: string;
    formTemplateID: number;
    formName: string;
    formFeatures: FormFeatureEnum;
    createdTime: string;
    createdBy: string;
    object: IeLynxObject;
    startTime: string;
    endTime: string;
    manual: boolean;
}

export interface IWaterLossEventModel {
    id: string;

    estimatedLoss?: number;
    estimatedLossUOM?: number;
    cause?: WaterLossCauseEnum;
    notes?: string;
    
    createdTime: Date | string;
    createdBy: string;
    object: IeLynxObject;
    startTime: Date | string;
    endTime: Date | string;
    manual: boolean;
}

export interface IObjectHistoryModel {
    alarmHistory: Array<IAlarmHistoryEventModel>;
    controlHistory: Array<IControlHistoryModel>;
    dataQualityEvents: Array<IDataQualityEventModel>;
    diagnosticEvents: Array<IDiagnosticEventModel>;
    memos: Array<IMemoModel>;
    formEvents: Array<IFormEventModel>;
    waterLossEvents: Array<IWaterLossEventModel>;
}

export enum EventDurationEnum {
    Recent100 = 0,
    Last24Hours = 1,
    Last3Days = 2,
    Last7Days = 3,
    Last30Days = 4,
    Custom = 5
}


export interface IObjectHistoryExportOptions {
    notificationKey: string;
    mimeType: ApplicationMimeTypesEnum;
    duration: EventDurationEnum;
    beginDate: Date | undefined;
    endDate: Date | undefined;
    sortParameters: ISortParameters;
    includeMemos: boolean;
    includeAlarmEvents: boolean;
    includeControlEvents: boolean;
    filterText: string;
}

